import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import '../../css/table.css';
import { get } from 'lodash';
import { getComparator, stableSort, TableComponent } from '../../Common/Table';
import { useState } from 'react';
import { Tooltip, Button } from '@mui/material';
import { IoCloudUpload, IoCloudDownload } from 'react-icons/io5';
import SelectDropdown from '../../Common/SelectDropdown';

import { jobRequestsTableHeader } from '../../Fields/jobRequestFields';

import { useMediaQuery } from 'react-responsive';
import TableCard from '../../Common/TableCard';
import { useSelector } from 'react-redux';

export default function JobsList({
  tableRowsData,
  getListData,
  rowsPerPage,
  setRowsPerPage,
  totalCount,
  page,
  setPage,
  openModal,
  register,
  errors,
  onDownload, // required to download
}) {
  const isTabletMid = useMediaQuery({ query: '(max-width: 768px)' });
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [searchVal, setSearchVal] = useState('');

  const headers = jobRequestsTableHeader;
  const { role } = useSelector((state) => state.user);

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    await getListData(Number(newPage + 1), rowsPerPage, '');
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    getListData(1, parseInt(event.target.value), '');
  };

  const handleSearchFieldDropdown = (e) => {
    if (searchVal) {
      getListData(1, rowsPerPage, searchVal, e.target.value);
    }
  };

  const componentDisplay = () => {
    const cells = headers?.filter(
      (cell) =>
        cell.id === 'name' ||
        cell.id === 'phoneNumber' ||
        cell.id === 'reference'
    );
    return (
      <div className="lg:mr-3 lg:w-52 text-center mb-[-15px] w-96">
        {headers.length > 0 && (
          <SelectDropdown
            fieldName="searchField"
            options={cells}
            optionsLabelKey="label"
            optionsValueKey="id"
            register={register}
            onChange={handleSearchFieldDropdown}
            errors={errors}
            fieldType="select"
            className="min-h-[auto] ml-3 w-48 border-1 bg-light py-2 text-sm text-gray-900 bg-white-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
            emptyOption={false}
          />
        )}
      </div>
    );
  };

  // helper to render truncated label for a key
  const renderKeyLabel = (key, max = 40) =>
    key ? (key.length > max ? `${key.slice(0, max)}...` : key) : '-';

  return (
    <React.Fragment>
      <div className="taskList mx-2 shadow-lg bg-white rounded-lg mt-2 p-3">
        <div style={{ width: '100%' }}>
          <TableComponent
            numSelected={0}
            searchVal={searchVal}
            headingText={'Job Requests'}
            order={order}
            searchBar={true}
            orderBy={orderBy}
            rowCount={tableRowsData.length || 0}
            tableRowsData={tableRowsData}
            headCells={headers}
            setOrder={setOrder}
            setOrderBy={setOrderBy}
            setSearchVal={setSearchVal}
            rowsPerPage={rowsPerPage}
            getAllData={getListData}
            componentDisplay={componentDisplay}
          >
            <TableBody className="table-body">
              {tableRowsData &&
                tableRowsData.length > 0 &&
                stableSort(tableRowsData, getComparator(order, orderBy)).map(
                  (row, index) => {
                    return (
                      <TableRow hover tabIndex={-1} key={index}>
                        {headers.map((cell) => {
                          return (
                            <TableCell
                              key={cell.id + index}
                              className={cell.id === 'sno' ? 'sno-column' : ''}
                            >
                              {cell.id === 'action' ? (
                                <div className="justify-around items-center flex">
                                  <div
                                    onClick={(e) => {
                                      if (role !== 'user') {
                                        openModal(row, e);
                                      }
                                    }}
                                    style={{
                                      pointerEvents:
                                        role === 'user' ? 'none' : 'auto',
                                      opacity: role === 'user' ? 0.5 : 1,
                                    }}
                                  >
                                    <IoCloudUpload
                                      size={23}
                                      className="cursor-pointer text-blue-600 hover:text-blue-800 transition"
                                    />
                                  </div>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) =>
                                      onDownload && onDownload(row, e)
                                    }
                                    disabled={!onDownload}
                                  >
                                    <IoCloudDownload
                                      size={23}
                                      className="cursor-pointer text-blue-600 hover:text-blue-800 transition"
                                    />
                                  </Button>
                                </div>
                              ) : cell.id === 'sno' ? (
                                index + 1
                              ) : cell.id === 'status' ? (
                                <div
                                  className={`justify-center flex capitalize
                                     hover:font-bold`}
                                >
                                  {get(row, cell.id) === 'inprogress'
                                    ? 'In Progress'
                                    : get(row, cell.id)}
                                </div>
                              ) : (
                                <Tooltip title={get(row, cell.id)}>
                                  <span>
                                    {typeof get(row, cell.id) === 'string' &&
                                    get(row, cell.id)?.length > 30
                                      ? `${get(row, cell.id)?.slice(0, 30)}...`
                                      : // if it's not a string, show a safe representation
                                      typeof get(row, cell.id) === 'object'
                                      ? JSON.stringify(get(row, cell.id))
                                      : get(row, cell.id)}
                                  </span>
                                </Tooltip>
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  }
                )}
            </TableBody>
          </TableComponent>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={'Entries per page: '}
            labelDisplayedRows={({ from, to, count }) =>
              `Showing ${from}-${to} of ${count} entries`
            }
          />
        </div>
      </div>
    </React.Fragment>
  );
}
